import { createSelector } from 'reselect';
import ImpcStockLevelsColumns from '../../containers/ImpcStockLevelsColumns';
import TableDefinitions from '../../../../common/TableDefinitions';

export const getAllIsLoading = (state) => state.listing.IMPC_STOCK_LEVELS_ALL_LIST.isLoading;
export const getAllData = TableDefinitions.IMPC_STOCK_LEVELS_ALL_LIST.getDataFunction();
export const getAllColumns = createSelector(getAllData, ImpcStockLevelsColumns);

export const getAlertsIsLoading = (state) => state.listing.IMPC_STOCK_LEVELS_WITH_ALERTS_LIST.isLoading;
export const getAlertsData = TableDefinitions.IMPC_STOCK_LEVELS_WITH_ALERTS_LIST.getDataFunction();
export const getAlertsColumns = createSelector(getAlertsData, ImpcStockLevelsColumns);

export const getCepIsLoading = (state) => state.listing.IMPC_STOCK_LEVELS_WITH_CENTRAL_ENTRY_POINT.isLoading;
export const getCepData = TableDefinitions.IMPC_STOCK_LEVELS_WITH_CENTRAL_ENTRY_POINT.getDataFunction();
export const getCepColumns = createSelector(getCepData, ImpcStockLevelsColumns);
